import { Difficulty, ExercisePackageFullSizeDto } from '@therame/shared';

export class ExerciseFilter {
  bodyRegionIds: Set<string> = new Set();
  difficulties: Set<Difficulty> = new Set();
  exercisePackage?: ExercisePackageFullSizeDto = undefined;
  searchText = '';
  onlyFavourites = false;
  onlyOwnExercises = false;
  onlyOfficeExercises = false;
  onlyWithDevice = false;
  onlyWithoutDevice = false;
}
